import { Navigate, useLocation } from 'react-router';

import { AuthStateType, useAuth } from '../../hooks/useAuth';
import { getSafeFromLocation } from '../../utils/navigation';
import { AuthPage } from '../AuthPage';

export function AuthRoute() {
  const [auth] = useAuth();
  const location = useLocation();

  if (auth.type === AuthStateType.Verifying) {
    return (
      <div className="min-h-screen bg-neutral-950 flex items-center justify-center">
        <div className="text-white">Loading…</div>
      </div>
    );
  }

  if (auth.type === AuthStateType.Authenticated) {
    return (
      <Navigate to={getSafeFromLocation(location.state?.from) ?? '/'} replace />
    );
  }

  return <AuthPage />;
}
